module.exports = __webpack_public_path__ + "media/images/share-tw-d0d5cd44c7745eb2c2e5f05d7593f308.svg";